'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _AccessibleButton = require('../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This should be below the dialog level (4000), but above the rest of the UI (1000-2000).
// We sit in a context menu, so this should be given to the context menu.
var EMOJIPICKER_Z_INDEX = 3500; /*
                                Copyright 2018 New Vector Ltd
                                
                                Licensed under the Apache License, Version 2.0 (the "License");
                                you may not use this file except in compliance with the License.
                                You may obtain a copy of the License at
                                
                                    http://www.apache.org/licenses/LICENSE-2.0
                                
                                Unless required by applicable law or agreed to in writing, software
                                distributed under the License is distributed on an "AS IS" BASIS,
                                WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                See the License for the specific language governing permissions and
                                limitations under the License.
                                */

var EmojiPickerButton = function (_React$Component) {
    (0, _inherits3.default)(EmojiPickerButton, _React$Component);

    function EmojiPickerButton(props) {
        (0, _classCallCheck3.default)(this, EmojiPickerButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPickerButton.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerButton)).call(this, props));

        _this._onShowEmojiClick = _this._onShowEmojiClick.bind(_this);
        _this._onHideEmojiClick = _this._onHideEmojiClick.bind(_this);
        _this._onEmojiChoose = _this._onEmojiChoose.bind(_this);
        _this._onWidgetAction = _this._onWidgetAction.bind(_this);
        _this._onResize = _this._onResize.bind(_this);
        _this._onFinished = _this._onFinished.bind(_this);

        _this.popoverWidth = props.width || 311;
        _this.popoverHeight = props.height || 408;

        _this.state = {
            showEmojis: false,
            imError: null,
            emojipickerX: null,
            emojipickerY: null,
            stickerpickerWidget: null,
            widgetId: null
        };
        return _this;
    }

    (0, _createClass3.default)(EmojiPickerButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Close the sticker picker when the window resizes
            window.addEventListener('resize', this._onResize);

            this.dispatcherRef = _dispatcher2.default.register(this._onWidgetAction);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this._onResize);
            if (this.dispatcherRef) {
                _dispatcher2.default.unregister(this.dispatcherRef);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this._sendVisibilityToWidget(this.state.showEmojis);
        }
    }, {
        key: '_imError',
        value: function _imError(errorMsg, e) {
            console.error(errorMsg, e);
            this.setState({
                showEmojis: false,
                imError: (0, _languageHandler._t)(errorMsg)
            });
        }
    }, {
        key: '_onWidgetAction',
        value: function _onWidgetAction(payload) {
            switch (payload.action) {
                case "user_widget_updated":
                    this.forceUpdate();
                    break;
                case "stickerpicker_close":
                    this.setState({ showEmojis: false });
                    break;
                case "show_right_panel":
                case "hide_right_panel":
                case "show_left_panel":
                case "hide_left_panel":
                    this.setState({ showEmojis: false });
                    break;
            }
        }
    }, {
        key: '_sendVisibilityToWidget',
        value: function _sendVisibilityToWidget(visible) {
            return;
        }
    }, {
        key: '_onEmojiChoose',
        value: function _onEmojiChoose(emojiUnicode) {
            var _this2 = this;

            var input = this.props.input;

            if (input && input._editorRef) {
                input._editorRef._insertTextAtLastPosition(emojiUnicode);
                this._onHideEmojiClick();
            } else {
                setTimeout(function () {
                    _this2._onEmojiChoose(emojiUnicode);
                }, 100);
            }
        }
    }, {
        key: '_getEmojipickerContent',
        value: function _getEmojipickerContent() {
            var EmojiPicker = _index2.default.getComponent('emojipicker.EmojiPicker');
            return _react2.default.createElement(EmojiPicker, {
                onChoose: this._onEmojiChoose,
                showQuickReactions: false,
                showPreview: false,
                showHeader: false,
                theme: this.props.theme
            });
        }

        // Dev note: this isn't jsdoc because it's angry.
        /*
         * Show the sticker picker overlay
         * If no stickerpacks have been added, show a link to the integration manager add sticker packs page.
         */

    }, {
        key: '_onShowEmojiClick',
        value: function _onShowEmojiClick(e) {
            var menuOptions = {};
            var buttonRect = e.target.getBoundingClientRect();
            // The window X and Y offsets are to adjust position when zoomed in to page
            var buttonLeft = buttonRect.left + window.pageXOffset;
            var buttonTop = buttonRect.top + window.pageYOffset;
            menuOptions.left = buttonLeft - this.popoverWidth + buttonRect.width;
            // 40px is to allow spacing between the icon and the popup
            menuOptions.top = buttonTop - (this.popoverHeight + 24);
            this.setState({
                menuOptions: menuOptions,
                showEmojis: true
            });
        }

        /**
         * Trigger hiding of the sticker picker overlay
         * @param  {Event} ev Event that triggered the function call
         */

    }, {
        key: '_onHideEmojiClick',
        value: function _onHideEmojiClick(ev) {
            this.setState({ showEmojis: false });
        }

        /**
         * Called when the window is resized
         */

    }, {
        key: '_onResize',
        value: function _onResize() {
            this.setState({ showEmojis: false });
        }

        /**
         * The stickers picker was hidden
         */

    }, {
        key: '_onFinished',
        value: function _onFinished() {
            this.setState({ showEmojis: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var ContextualMenu = _index2.default.getComponent('structures.ContextualMenu');
            var GenericElementContextMenu = _index2.default.getComponent('context_menus.GenericElementContextMenu');
            var emojiButton = void 0;

            var emojiPicker = _react2.default.createElement(ContextualMenu, (0, _extends3.default)({}, this.state.menuOptions, {
                elementClass: GenericElementContextMenu,
                chevronFace: "none",
                element: this._getEmojipickerContent(),
                onFinished: this._onFinished,
                closeMenu: this._onFinished,
                menuPaddingTop: 0,
                menuPaddingLeft: 0,
                menuPaddingRight: 0,
                zIndex: EMOJIPICKER_Z_INDEX,
                hasBackground: true
            }));

            if (this.state.showEmojis) {
                // Show hide-stickers button
                emojiButton = _react2.default.createElement(_AccessibleButton2.default, {
                    id: 'emojiButton',
                    key: 'controls_hide_stickers',
                    className: 'mx_MessageComposer_button mx_MessageComposer_emoji',
                    onClick: this._onHideEmojiClick,
                    title: (0, _languageHandler._t)("Hide Emojis")
                });
            } else {
                // Show show-stickers button
                emojiButton = _react2.default.createElement(_AccessibleButton2.default, {
                    id: 'emojiButton',
                    key: 'controls_show_stickers',
                    className: 'mx_MessageComposer_button mx_MessageComposer_emoji',
                    onClick: this._onShowEmojiClick,
                    title: (0, _languageHandler._t)("Show Emojis")
                });
            }
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                emojiButton,
                this.state.showEmojis && emojiPicker
            );
        }
    }]);
    return EmojiPickerButton;
}(_react2.default.Component);

exports.default = EmojiPickerButton;
module.exports = exports['default'];
//# sourceMappingURL=EmojiPickerButton.js.map